export const GET_REMINDERS = 'GET_REMINDERS';
export const GET_REMINDER_DETAILS = 'GET_REMINDER_DETAILS';
export const UPDATE_REMINDER = 'UPDATE_REMINDER';
